export default __webpack_public_path__ + "static/media/contestIcon.e51a7828.svg";